import { required, or, email } from 'vuelidate/lib/validators'

const isNotEmailType = (value, vm) => vm.type !== 'email'
const isNotCheckboxType = (value, vm) => vm.type !== 'checkbox'
const isTrue = (value) => value === true

export default {
  data: function() {
    return {
      inputsToBeValidated: [
        // Demo Data Structure
        //  { id: '462464', type: 'email', value: 'joe@somemail.com' }
      ],
    }
  },
  validations() {
    return {
      inputsToBeValidated: {
        $each: {
          value: {
            required,
            // if component is not email validation passes
            // if component is email, the email validation has to pass
            customEmail: or(isNotEmailType, email),
            customCheckbox: or(isNotCheckboxType, isTrue),
          },
        },
      },
    }
  },
  watch: {
    targetStepIndex() {
      // Update 'inputsToBeValidated' list if Step changes
      const inputsThatNeedValidation = this.widget.steps[this.targetStepIndex].contentItems.filter(
        (item) => {
          return item.category === 'form'
        }
      )

      inputsThatNeedValidation.forEach((contentItem) => {
        if (contentItem.settings.required) {
          // get the index at which the new item is positioned
          const contentItemType = contentItem.settings.type
            ? contentItem.settings.type
            : contentItem.type
          const index = this.inputsToBeValidated.push({
            id: contentItem.id,
            type: contentItemType,
            value: '',
          })

          if (this.feedback.answer.itemsList.includes(contentItem.id)) {
            this.inputsToBeValidated[index].value = this.feedback.answer.items[contentItem.id].value
          }
        }
      })
    },
  },
  mounted() {
    const inputsThatNeedValidation = this.widget.steps[this.targetStepIndex].contentItems.filter(
      (item) => {
        return item.category === 'form'
      }
    )

    inputsThatNeedValidation.forEach((contentItem) => {
      if (contentItem.settings.required) {
        const contentItemType = contentItem.settings.type
          ? contentItem.settings.type
          : contentItem.type
        // get the index at which the new item is positioned
        const index = this.inputsToBeValidated.push({
          id: contentItem.id,
          type: contentItemType,
          value: '',
        })

        if (this.feedback.answer.itemsList.includes(contentItem.id)) {
          this.inputsToBeValidated[index].value = this.feedback.answer.items[contentItem.id].value
          // Reflect that value has been touched by user
          this.$v.inputsToBeValidated.$each[index].$touch()
        }
      }
    })
  },
  methods: {
    getValidationIndex: function(componentID) {
      return this.inputsToBeValidated.findIndex((item) => {
        return item.id === componentID
      })
    },
    triggerUpdateValidationList: function(data) {
      const index = this.inputsToBeValidated.findIndex((item) => {
        return item.id === data.id
      })

      if (index !== -1) {
        this.inputsToBeValidated[index].value = data.value
        this.$v.inputsToBeValidated.$each[index].$touch()
      }
    },
  },
}
